import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../image/logo.png";
import {
  MdHome,
  MdIntegrationInstructions,
  MdChevronLeft,
  MdChevronRight,
  MdPerson,
  MdBadge,
  MdEventBusy,
  MdAssignmentTurnedIn,
  MdHowToReg,
  MdAccessTime,
  MdLogout,
} from "react-icons/md";
import DescriptionIcon from '@mui/icons-material/Description';
import { hasAccessToModule } from "../rbac/hasAccess";

export const menuItems = [
  {
    moduleAccessId: 1,
    label: "Home",
    title: "Go to Home",
    icon: MdHome,
    to: "/",
  },
  {
    moduleAccessId: 2,
    label: "Master",
    icon: MdIntegrationInstructions,
    children: [
      {
        moduleAccessId: 51,
        label: "Employee Master",
        to: "/master/employeeMaster",
        icon: MdPerson,
      },
      {
        moduleAccessId: 52,
        label: "Master Equipment",
        to: "/master/masterEquipment",
        icon: MdBadge,
      },
      {
        moduleAccessId: 53,
        label: "Discipline",
        to: "/master/discipline",
        icon: MdBadge,
      },
      {
        moduleAccessId: 54,
        label: "Accreditation Scope",
        to: "/master/testMaster",
        icon: MdBadge,
      },
      {
        moduleAccessId: 55,
        label: "Unit Master",
        to: "/master/unit",
        icon: MdBadge,
      },
      {
        moduleAccessId: 56,
        label: "Holiday List",
        to: "/master/holiday",
        icon: MdBadge,
      },
      {
        moduleAccessId: 57,
        label: "Client",
        to: "/master/client",
        icon: MdPerson,
      },
      {
        moduleAccessId: 58,
        label: "User",
        to: "/master/usersList",
        icon: MdPerson,
      },
      {
        moduleAccessId: 59,
        label: "Roll Back List",
        to: "/master/rbacList",
        icon: MdBadge,
      },
      {
        moduleAccessId: 60,
        label: "Remarks",
        to: "/master/remarkList",
        icon: MdBadge,
      },
      {
        moduleAccessId: 61,
        label: "Settings",
        to: "/master/settingList",
        icon: MdBadge,
      },
      {
        moduleAccessId: 62,
        label: "Table Template",
        to: "/master/templateList",
        icon: MdBadge,
      },
      {
        moduleAccessId: 63,
        label: "Datasheet Templatee",
        to: "/master/datasheetTemplate",
        icon: MdBadge,
      },
    ],
  },
  {
    moduleAccessId: 3,
    label: "Job Register",
    to: "/jobRegister",
    icon: MdBadge,
  },
  {
    moduleAccessId: 4,
    label: "Inward",
    to: "/inwardList",
    icon: MdBadge,
  },
  {
    moduleAccessId: 7,
    label: "ObservationSheet",
    to: "/datasheetList",
    icon: DescriptionIcon,
  },
  {
    moduleAccessId: 8,
    label: "Certificate",
    to: "/certificateList",
    icon: DescriptionIcon,
  },
    {
    moduleAccessId: 10,
    label: "Requirements",
    icon: MdBadge,
     children: [
      {
        moduleAccessId: 80,
        label: "Requirement List",
         to: "/requirementList",
        icon: MdAssignmentTurnedIn,
      },
      {
        moduleAccessId: 81,
        label: "Requirement Report",
        to: "/requirementReport",
        icon: MdAssignmentTurnedIn,
      },
    ]
  },
  {
    moduleAccessId: 5,
    label: "Leave",
    icon: MdEventBusy,
    children: [
      {
        moduleAccessId: 91,
        label: "Leave Request",
        to: "/leave/apply",
        icon: MdAssignmentTurnedIn,
      },
      {
        moduleAccessId: 92,
        label: "Leave Report",
        to: "/leave/report",
        icon: MdAssignmentTurnedIn,
      },
        {
        moduleAccessId: 93,
        label: "Leave Balance Report",
        to: "/leave/balanceReport",
        icon: MdAssignmentTurnedIn,
      },
            {
        moduleAccessId: 94,
        label: "Leave Regularization",
        to: "/leave/leaveRegularization",
        icon: MdAssignmentTurnedIn,
      },
    ],
  },
  {
    moduleAccessId: 6,
    label: "Attendance",
    icon: MdBadge,
    children: [
      {
        moduleAccessId: 101,
        label: "Attendance Report",
        to: "/attendance",
        icon: MdHowToReg,
      },
      {
        moduleAccessId: 102,
        label: "Attendance Regularization",
        to: "/attendanceRegularizationList",
        icon: MdHowToReg,
      },
      // {
      //   moduleAccessId: 57,
      //   label: "Late Coming Report",
      //   to: "/attendance",
      //   icon: MdAccessTime,
      // },
      // {
      //   moduleAccessId: 57,
      //   label: "Early Going Report",
      //   to: "/attendance",
      //   icon: MdLogout,
      // },
    ],
  },
  {
    moduleAccessId: 9,
    label: "Report",
    icon: MdEventBusy,
    children: [
      {
        moduleAccessId: 151,
        label: "Summary Report",
        to: "/summaryReport",
        icon: MdAssignmentTurnedIn,
      },
      {
        moduleAccessId: 152,
        label: "Progress Report",
        to: "/progressReport",
        icon: MdAssignmentTurnedIn,
      },
      {
        moduleAccessId: 153,
        label: "Approval Status Report",
        to: "/approvalStatusReport",
        icon: MdAssignmentTurnedIn,
      },
    ],
  },
];

export default function Sidebar({ isSidebarOpen, setSidebarOpen, isMobile }) {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  const [tooltip, setTooltip] = useState({
    visible: false,
    text: "",
    x: 0,
    y: 0,
  });

  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleDropdown = (label) => {
    setOpenDropdowns((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  // added session storage navigation logic
  let previouspath = sessionStorage.getItem("currentPath");

  const clearSearchFilterSessionStorage = (to) => {
    const shouldConfirmNavigation = [
      "/editdatasheet",
      "/editInward",
      "/master/editTestMaster",
      "/master/editTemplate",
      "/master/editDatasheetTemplate",
    ].some((route) => pathname.startsWith(route));

    if (shouldConfirmNavigation) {
      if (window.confirm("Are you sure you want to quit?")) {
        if (to !== previouspath) {
          sessionStorage.removeItem("searchBy");
          sessionStorage.removeItem("searchKey");
          sessionStorage.removeItem("searched");
          sessionStorage.removeItem("currentPath");
          sessionStorage.removeItem("ListPageCount");
          sessionStorage.removeItem("ListRowsPerPage");
          sessionStorage.removeItem("fromDate");
          sessionStorage.removeItem("toDate");
          sessionStorage.removeItem("selectEmployee");
        }
        navigate(to);
      }
    } else {
      if (to !== previouspath) {
        sessionStorage.removeItem("searchBy");
        sessionStorage.removeItem("searchKey");
        sessionStorage.removeItem("searched");
        sessionStorage.removeItem("currentPath");
        sessionStorage.removeItem("ListPageCount");
        sessionStorage.removeItem("ListRowsPerPage");
        sessionStorage.removeItem("fromDate");
        sessionStorage.removeItem("toDate");
        sessionStorage.removeItem("selectEmployee");
      }
      navigate(to);
    }
  };

  return (
      <aside
        className={`transition-all duration-300 z-40 flex-shrink-0 bg-white border-r border-gray-100
        ${isMobile
            ? isSidebarOpen
              ? "fixed left-0 top-[70px] w-64 h-[calc(100vh-90px)]"
              : "fixed -left-64 top-[70px] w-64 h-[calc(100vh-90px)]"
            : isSidebarOpen
              ? "w-64 h-full"
              : "w-[100px] h-full"
          }`}
      >
        <div
          className="h-full flex flex-col shadow-lg  px-3 py-1"
        >
          {/* Sidebar below header */}
          {/* <div className="h-4"></div> */}

          <nav
            className="space-y-3 flex-1 overflow-y-auto custom-sidebar-scroll no-scrollbar overflow-x-hidden"
          >
            {menuItems
              ?.filter(
                (item) =>
                  !item.moduleAccessId || hasAccessToModule(item.moduleAccessId)
              )
              ?.map(({ label, title, icon: Icon, to, children }, index) => {
                const isParentActive = children?.some(child => location.pathname === child.to);
                const isActive = location.pathname === to || isParentActive;

                if (children) {
                  const isOpen = openDropdowns[label];
                  return (
                    <div key={index} className="mb-2">
                      <button
                        type="button"
                        onClick={() => toggleDropdown(label)}
                        onMouseEnter={(e) => {
                          const rect = e.currentTarget.getBoundingClientRect();
                          setTooltip({
                            visible: true,
                            text: label,
                            x: rect.left + 50,
                            y: rect.top + (rect.height / 2) - 10,
                          });
                        }}
                        onMouseLeave={() =>
                          setTooltip((prev) => ({ ...prev, visible: false }))
                        }
                        className={`flex items-center w-full p-2 rounded-md transition-all duration-200 ${isOpen || isActive
                          ? "text-black font-bold"
                          : "text-gray-600 hover:text-black"
                          }`}
                      >
                        <Icon
                          className={`h-6 w-6 flex-shrink-0 transition-colors duration-200 ${(isOpen || isActive) ? "text-blue-600" : ""} ${isSidebarOpen ? "mr-4" : ""}`}
                        />
                        {isSidebarOpen && (
                          <>
                            <span className="text-[15px] font-medium truncate">{label}</span>
                            <span className={`ml-auto flex-shrink-0 transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`}>
                              <MdChevronRight size={20} />
                            </span>
                          </>
                        )}
                      </button>

                      <div 
                        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"}`}
                      >
                        <div className="space-y-[2px] py-1">
                          {children
                            ?.filter(
                              (child) =>
                                !child.moduleAccessId ||
                                hasAccessToModule(child.moduleAccessId)
                            )
                            ?.map((child, idx) => {
                              const isChildActive = location.pathname === child.to;
                              return (
                                <div
                                  key={idx}
                                  onClick={() => {
                                    clearSearchFilterSessionStorage(child.to);
                                    isMobile && setSidebarOpen(false);
                                  }}
                                  onMouseEnter={(e) => {
                                    const rect = e.currentTarget.getBoundingClientRect();
                                    setTooltip({
                                      visible: true,
                                      text: child.label,
                                      x: rect.left + 65,
                                      y: rect.top + (rect.height / 2) - 10,
                                    });
                                  }}
                                  onMouseLeave={() =>
                                    setTooltip((prev) => ({ ...prev, visible: false }))
                                  }
                                  className={`flex items-center text-[14px] py-2 pl-[28px] pr-2 rounded-md cursor-pointer transition-all duration-200 ${isChildActive
                                    ? "text-black font-bold"
                                    : "text-gray-500 hover:text-black"
                                    }`}
                                >
                                  <child.icon className={`h-5 w-5 flex-shrink-0 transition-colors duration-200 ${isChildActive ? "text-blue-600" : ""} ${isSidebarOpen ? "mr-3" : ""}`} />
                                  {isSidebarOpen && <span className="truncate">{child.label}</span>}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  );
                }

                return (
                  <div
                    key={index}
                    onClick={() => {
                      clearSearchFilterSessionStorage(to);
                      isMobile && setSidebarOpen(false);
                    }}
                    onMouseEnter={(e) => {
                      const rect = e.currentTarget.getBoundingClientRect();
                      setTooltip({
                        visible: true,
                        text: title || label,
                        x: rect.left + 50,
                        y: rect.top + (rect.height / 2) - 10,
                      });
                    }}
                    onMouseLeave={() =>
                      setTooltip((prev) => ({ ...prev, visible: false }))
                    }
                    className={`flex items-center p-2 rounded-md cursor-pointer transition-all duration-200 ${isActive
                      ? "text-black font-bold"
                      : "text-gray-600 hover:text-black"
                      }`}
                  >
                    <Icon
                      className={`h-6 w-6 flex-shrink-0 ${isSidebarOpen ? "mr-4" : ""} ${isActive ? "text-blue-600" : ""}`}
                    />
                    {isSidebarOpen && <span className="text-[15px] font-medium truncate">{label}</span>}
                  </div>
                );
              })}
          </nav>
        </div>

        {/* Tooltip */}
        {tooltip.visible && !isSidebarOpen && !isMobile && (
          <div
            className="fixed px-2.5 py-1.5 bg-gray-900 border border-gray-700 shadow-xl text-white text-xs font-medium tracking-wide rounded-md z-[9999] pointer-events-none transition-opacity duration-150"
            style={{
              top: tooltip.y,
              left: tooltip.x,
            }}
          >
            {tooltip.text}
          </div>
        )}
      </aside>
  );
}
